export default "__VITE_ASSET__17f9993b__"